export enum AlignmentType {
    Undefined,
    Left,
    Center,
    Right
}
